export default (el) => {
    const body = document.body;
    const nav = document.querySelector('.page-nav');

    let toggleItems = document.querySelectorAll('[data-page-nav-toggle]')

    toggleItems.forEach((toggle) => {
        toggle.addEventListener('click', (event) => {
            event.preventDefault();
            el.classList.toggle('-active');
            body.classList.toggle('-no-overflow')
            nav.classList.toggle('-active');
        })
    });

};
